import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Sparkles, Loader2, Tag } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";

const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "");

export default function WhatsNew() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/whats-new").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="whats-new-page">
      <PageHeader title="What's New" subtitle="Latest updates and improvements to PK AI Calling" />

      {items === null ? (
        <div className="py-16 text-center"><Loader2 className="w-6 h-6 animate-spin mx-auto text-indigo-500" /></div>
      ) : items.length === 0 ? (
        <Card className="border shadow-none p-10 text-center" data-testid="whats-new-empty">
          <Sparkles className="w-8 h-8 mx-auto text-indigo-300 mb-3" />
          <div className="text-sm text-slate-500">No updates published yet. Check back soon!</div>
        </Card>
      ) : (
        <div className="relative pl-6">
          <div className="absolute left-[7px] top-2 bottom-2 w-px bg-slate-200 dark:bg-white/10" />
          <div className="space-y-5">
            {items.map((p, i) => (
              <div key={i} className="relative" data-testid={`whats-new-item-${i}`}>
                <div className="absolute -left-6 top-1.5 w-3.5 h-3.5 rounded-full bg-indigo-500 ring-4 ring-indigo-500/15" />
                <Card className="border shadow-none p-5">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full" style={{ background: "rgba(79,70,229,0.1)", color: "#4f46e5" }}>
                      <Tag className="w-3 h-3" />v{p.version}
                    </span>
                    <span className="text-xs text-slate-400">{fmtDate(p.created_at)}</span>
                  </div>
                  {p.notes ? (
                    <div className="text-sm text-slate-600 dark:text-slate-300 whitespace-pre-wrap leading-relaxed">{p.notes}</div>
                  ) : (
                    <div className="text-sm text-slate-400 italic">New release available.</div>
                  )}
                </Card>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
